import { Card, CardBody, CardHeader, TabPane } from "reactstrap";
import { TabCardProp } from "../../../../../types/Applications";
import ViewBookmark from "../../View";
import SearchNotFoundClass from "../../../../../coreComponents/SearchNotFoundClass";

// This component represents a tab content section inside a tabbed interface.
const TabCard: React.FC<TabCardProp> = ({ tabId, title }) => {
  return (
    <TabPane tabId={tabId}>
      <Card className="mb-0">
        <CardHeader className="d-flex">
          <h4 className="mb-0">{title}</h4>
          <ViewBookmark />
        </CardHeader>
        <CardBody>
          <SearchNotFoundClass word="Bookmark" />
        </CardBody>
      </Card>
    </TabPane>
  );
};

export default TabCard;
